export type DictationPlatform = 'windows' | 'mac';

interface PlatformSource {
  userAgentData?: { platform?: string };
  platform?: string;
  maxTouchPoints?: number;
}

/**
 * Which operating system's dictation shortcut applies: Windows (Windows + H) or macOS (Fn twice).
 * `userAgentData.platform` first, `navigator.platform` as the fallback. Anything else, phones and
 * tablets included (an iPad that says "MacIntel" still has a touch screen), gets no tip.
 */
export function dictationPlatform(source: PlatformSource = navigator): DictationPlatform | null {
  const named = source.userAgentData?.platform;
  const platform = named !== undefined && named !== '' ? named : (source.platform ?? '');
  if (/^win/i.test(platform)) return 'windows';
  if (/^mac/i.test(platform) && (source.maxTouchPoints ?? 0) <= 1) return 'mac';
  return null;
}
